(ns app.front.ui.tags
  (:require [app.front.util :as futil]
            [core.front.carbon :as cc]))

(defn tag
  "Make a tag component with a label text and optional clickable icons on the right side.
   Takes a property map as only argument.
   The icons are tabbable and respond to Enter key presses like buttons.

   Required props
   `:label-text`

   Optional props
   `disabled` (boolean, default false)
   `:buttons` [{:icon        (from app.front.icons)
                :description (icon description for mouseover and accessibility)
                :on-click    (function with no arguments)
               }]"
  [{:keys [label-text disabled buttons]}]
  [:div.mt-1.mr-1.p-1.h-8.border.border-solid.border-gray-600.rounded.bg-ui-light-gray.justify-between.flex.items-center
   [:div.inline-block.mx-2.relative
    {:class (when disabled "text-gray-600")}
    label-text]
   (futil/for-frag [{:keys [icon description on-click]} (remove nil? buttons)]
     [:div.inline-block.p-0.m-0.h-6.w-6.rounded
      (when-not disabled
        {:tab-index    0
         :class        ["cursor-pointer" "hover:bg-gray-400"]
         :on-click     on-click
         :on-key-press #(when (= (.-key %) "Enter")
                          (on-click))})
      (cc/icon {:icon        icon
                :description description
                :fill        (if disabled "gray" "var(--ui-violet-70)")
                :class-name  "p-1 h-6 w-6"})])])
